import MobileHeader from '@/components/MobileHeader';
import PageHeader from '@/components/PageHeader';
import WrapperContainer from '@/components/WrapperContainer/index';
import AddonBaggagesBottom from '@/containers/AddonBaggagesBottom';
// import FlightTripDetailToState from '@/containers/FlightTripDetailToState';
import TripCardDetail from '@/containers/TripCardDetail';
import { setReturnDate, setChooseReturn, setSelectedDate } from '@/slices/calendar/calendarSlice';
import { useVerifyFlightMutation } from '@/slices/gom/apis/orderApi';
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import { pr } from '@/utils/pxToRem';
import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { format, isAfter, parse } from 'date-fns';
import { get, isEmpty } from 'lodash';
import { GetServerSidePropsContext, NextPage } from 'next';
import { useRouter } from 'next/router';
import qs from 'qs';
import React, { useEffect, useState } from 'react';
import TripDetailMetaHeader from './header';
import DataAirportVn from '@/mappings/airport_vn.json';
import { transformFilter, useLazyGetFlightByIdQuery } from '@/slices/flightData/apis/flightDataApi';
import { transformAreaData } from '@/utils/transformAreaData';
import { getAccessToken } from '../api/getToken';
import { addAllPointsHomePoints, adjustAllPassengers } from '@/slices/area/slices/searchFlightFormSlice';
import { PointRequest } from '@/slices/area/slices';
import { resetSelectedBaggage } from '@/slices/baggage/slices/baggageSlice';
import { addFlight, addReturnFlight, removeReturnFlight } from '@/slices/selectedFlight/slices/selectedFlightSlice';
import GTagWrapper from '@/containers/GTagRouteFlight';
import { resetSortingFlight } from '@/slices/sortingFlight/sortingFlightSlice';
import { resetFilter, updateFilter } from '@/slices/filterFlight/filterFlightSlice';
import { generateFlightStatisticsRequests } from '@/utils/generateFlightStatisticsRequests';
import { transformCountResponse } from '@/utils/transformCountResponse';
import { addMinPrice } from '@/slices/flightData/slices/flightDataSlice';
import camelcaseKeysDeep from 'camelcase-keys-deep';
import { generateFlightCountReqeust } from '@/utils/generateFlightRequest';
import { DEFAULT_TIME_OBJ } from '@/utils/constants';
import { initialState as initialFliterState } from '@/slices/filterFlight/filterFlightSlice';
import { useCheckIsMobile } from '@/utils/hooks/use-check-is-mobile';
import dynamic from 'next/dynamic';
import { resetGlobalAll } from '@/slices/global/globalSlice';
import { store, persistor } from '@/utils/store';
import { queryFareConfig } from '@/utils/queryFareConfig';
import { addFareConfig } from '@/slices/fareRule/slices/fareRuleSlice';

const Container = styled('div')(({ theme }) => ({
  background: theme.palette.white1,
  height: '100%',
}));

const TripDetail: NextPage = (props: any = {}) => {
  const [isStateRehydrated, setIsStateRehydrated] = useState(false);
  const {
    startPoint: startPointProps,
    toPoint: toPointProps,
    passenger: passengerProps,
    fareConfig,
  } = props;

  const dispatch = useAppDispatch();
  const {
    query, push, asPath,
  } = useRouter();

  // Add flight data fetching hooks
  const [getFlightById, { data: clientFlightData }] = useLazyGetFlightByIdQuery();
  const [getReturnFlightById, { data: clientReturnFlightData }] = useLazyGetFlightByIdQuery();

  // Add rehydration tracking
  useEffect(() => {
    const unsubscribe = persistor.subscribe(() => {
      const { bootstrapped } = persistor.getState();
      if (bootstrapped) {
        setIsStateRehydrated(true);
        unsubscribe();
      }
    });

    return () => unsubscribe();
  }, []);

  const { type } = query; // depart or return
  if (type !== 'return') {
    dispatch(removeReturnFlight());
  }

  const departDate = get(query, 'date[depart]') as any;
  const returnDate = get(query, 'date[return]') as any;
  const selectedDate = useAppSelector((state) => state.calendar.selectedDate);
  const filter = useAppSelector((state) => state.filterFlight.filter);
  const isMobile = useCheckIsMobile();
  const global = useAppSelector((state) => state.global);

  useEffect(() => {
    if (type !== 'return') {
      dispatch(removeReturnFlight());
    }
  }, []);

  useEffect(() => {
    dispatch(resetGlobalAll());
    return () => { dispatch(resetGlobalAll()); };
  }, [global]);

  useEffect(() => {
    if (departDate) {
      setTimeout(() => {
        dispatch(setSelectedDate({
          dateObj: JSON.stringify({
            depart: new Date(departDate),
            return: returnDate ? new Date(returnDate) : null,
          }),
        }));
      }, 1000);
    }
  }, []);

  const [verifyFlight] = useVerifyFlightMutation();

  const passenger = {
    adt: +passengerProps?.adt || 1,
    chd: +passengerProps?.chd || 0,
    inf: +passengerProps?.inf || 0,
  };

  const selectedDateState = useAppSelector(
    (state) => state.calendar.selectedDate,
  );

  let { startPoint, toPoint } = useAppSelector(
    (state) => state.searchFlightForm,
  );
  const departFlight = useAppSelector((state) => state.selectedFlight.flight);

  if (!startPoint) {
    startPoint = startPointProps;
  }
  if (!toPoint) {
    toPoint = toPointProps;
  }

  const isFlowRedirectFromVex = get(query, 'referral_id') as any;

  const flight = useAppSelector((s) => s.selectedFlight.flight);
  const returnFlight = useAppSelector(
    (state) => state.selectedFlight.returnFlight,
  );

  // Use client-side data
  const flightDepartData = !isFlowRedirectFromVex ? flight : (!clientFlightData ? null : flight);
  const flightReturnData = !isFlowRedirectFromVex ? returnFlight : (!clientReturnFlightData ? null : returnFlight);

  const selectedFlightProps = type === 'return' ? flightReturnData : flightDepartData;
  const currentFlight: any = selectedFlightProps || (type === 'depart' || !type ? flight : returnFlight);

  useEffect(() => {
    if (!isEmpty(currentFlight) && currentFlight?.session) {
      const { adt, chd, inf } = passenger;
      const currentSchedule = get(currentFlight, 'route.schedules[0]') || {};
      const verifyPrice = (adt
    * (currentSchedule.totalPriceAdultOriginal || currentSchedule.totalPriceAdult))
    + (chd
      * (currentSchedule.totalPriceChildOriginal || currentSchedule.totalPriceChild))
    + (inf
      * currentSchedule.totalPriceInfant);

      verifyFlight({
        auto_issue: 0,
        fare_data_id: currentFlight?.fareDataId || 0,
        passenger_count_obj: passenger,
        list_flight: [
          {
            flight_id: currentFlight?.idIndex,
            flight_value:
              currentFlight?.route?.schedules
                ?.map?.((x: any) => x?.flightValue)
                .join(',') || '',
            leg: 0,
            airline: currentFlight?.airline || '',
            operation: currentSchedule?.operating || '',
            start_point: currentFlight?.startPoint || '',
            end_point: currentFlight?.endPoint || '',
            depart_date: format(
              parse(currentFlight?.date || '', 'yyyy-MM-dd', new Date()),
              'ddMMyyyy',
            ),
            depart_time: (currentFlight?.time || '').replace(':', ''),
            flight_number: currentFlight?.flightNumber || '',
            fare_class: currentSchedule.fareClass,
            price: verifyPrice,
          },
        ],
        session: currentFlight?.session || '',
        tourcode: '',
        cacode: '',
        viptext: '',
      });
    }
  }, [currentFlight]);

  useEffect(() => {
    if (!isStateRehydrated && !isFlowRedirectFromVex) {
      return; // Wait for state to be rehydrated
    }

    const queryFlightIdDepart = query['flightId[depart]'] as any;
    const queryFlightIdReturn = query['flightId[return]'] as any;
    const paramsSearchFlightId = {
      filter: {
        quantity: +passengerProps?.adt + +passengerProps?.chd,
        child_infant_count: +passengerProps?.chd + +passengerProps?.inf,
        infant_count: +passengerProps?.inf,
      },
    };

    if (queryFlightIdDepart && departFlight?.idIndex === queryFlightIdDepart && !isFlowRedirectFromVex) {
      dispatch(addFlight(departFlight as any));
    } else if (queryFlightIdDepart) {
      getFlightById({
        id: queryFlightIdDepart,
        params: qs.stringify(paramsSearchFlightId, {
          encode: false,
          skipNulls: true,
        }),
      });
    }

    if (queryFlightIdReturn && returnFlight?.idIndex === queryFlightIdReturn && !isFlowRedirectFromVex) {
      dispatch(addReturnFlight(returnFlight as any));
    } else if (queryFlightIdReturn) {
      getReturnFlightById({
        id: queryFlightIdReturn,
        params: qs.stringify(paramsSearchFlightId, {
          encode: false,
          skipNulls: true,
        }),
      });
    }

    if (!queryFlightIdReturn && isFlowRedirectFromVex) {
      dispatch(removeReturnFlight());
      dispatch(setChooseReturn({ chooseReturn: false }));
      dispatch(setReturnDate({ return: null }));
    }

    const pointArr = [] as PointRequest[];
    if (startPointProps) {
      pointArr.push({
        data: startPointProps,
        type: 'from',
      });
    }
    if (toPointProps) {
      pointArr.push({
        data: toPointProps,
        type: 'to',
      });
    }
    if (!isEmpty(pointArr)) {
      dispatch(addAllPointsHomePoints(pointArr));
    }

    if (passengerProps) {
      dispatch(adjustAllPassengers(passengerProps));
    }
    dispatch(resetSelectedBaggage());
    if (fareConfig) {
      dispatch(addFareConfig(fareConfig));
    }
  }, [isStateRehydrated, passengerProps, flight, returnFlight, query]);

  // Add effect to handle client-side fetched data
  useEffect(() => {
    if (clientFlightData) {
      const processedData = addMinPrice(camelcaseKeysDeep([clientFlightData]) as any);
      if (processedData?.[0]) {
        dispatch(addFlight(processedData?.[0]) as any);
      }
    }
  }, [clientFlightData]);

  useEffect(() => {
    if (clientReturnFlightData) {
      const processedData = addMinPrice(camelcaseKeysDeep([clientReturnFlightData]) as any);
      if (processedData?.[0]) {
        dispatch(addReturnFlight(processedData?.[0]) as any);
      }
    }
  }, [clientReturnFlightData]);
  return (
    <>
      <TripDetailMetaHeader
        startPoint={startPoint}
        toPoint={toPoint}
        company={currentFlight?.company?.name || ''}
        companySlug={currentFlight?.company?.unaccentedName?.split(' ').join('-') || ''}
      />
      {/* <FlightTripDetailToState> */}
      <Container>
        <GTagWrapper page="trip-detail" />
        <PageHeader />
        <MobileHeader
          onGoBack={() => {
            // TODO: GYL-712
            const queryString = asPath.split('?');
            push(`/route-flight?${queryString?.[1]}`);
          }}
          title="Chi tiết vé"
        />
        <Stack
          spacing={pr`16px`}
          direction="column"
          sx={{
            // paddingBottom: pr`50px`,
            mt: (theme) => theme.palette.medium,
          }}
        >
          <TripCardDetail
            selectedFlightProps={flightDepartData}
            isDepart
          />
          {query.type === 'return' && (
            <TripCardDetail
              selectedFlightProps={flightReturnData}
              isReturn
            />
          )}
        </Stack>
        <AddonBaggagesBottom
          onBtnClick={() => {
            if (query?.type === 'depart') {
              const params = qs.parse(asPath?.split?.('?')?.[1]) as any;
              const newParam = {
                ...params,
                type: 'return',
              };
              // dispatch(resetFilter());
              dispatch(resetSortingFlight());
              if (
                departFlight?.arrivalDate
                && isAfter(
                  new Date(departFlight?.arrivalDate || ''),
                  new Date(selectedDateState?.return),
                )
              ) {
                dispatch(updateFilter({
                  ...initialFliterState,
                  filter: {
                    ...initialFliterState.filter,
                    departureTime: {
                      max: filter?.departureTime?.max || DEFAULT_TIME_OBJ.max,
                      min: DEFAULT_TIME_OBJ.min,
                    },
                  },
                }));
              } else if (selectedDateState?.depart === selectedDateState?.return) {
                dispatch(updateFilter({
                  ...initialFliterState,
                  filter: {
                    ...initialFliterState.filter,
                    departureTime: {
                      max: filter?.departureTime?.max || DEFAULT_TIME_OBJ.max,
                      min: departFlight?.arrivalTime || '00:00',
                    },
                  },
                }));
              }
              push(
                `/route-flight?${qs.stringify(newParam, {
                  encode: false,
                  skipNulls: true,
                })}`,
              );
            } else push('/passenger');
          }}
        />
      </Container>
      {/* </FlightTripDetailToState> */}
    </>
  );
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=60, stale-while-revalidate=120',
  );

  const query: any = qs.parse(context.query as any);
  const {
    from, to, passenger, date, fare_class,
  } = query;

  const toAirports = DataAirportVn.airports
    .filter((ap) => ap.VxrAreaId === Number(to))
    ?.map((ap) => ({
      ...ap,
      id: ap.VxrAreaParentId,
      location: ap.CityName_Vi,
    }));
  const fromAirports = DataAirportVn.airports
    .filter((ap) => ap.VxrAreaId === Number(from))
    ?.map((ap) => ({
      ...ap,
      id: ap.VxrAreaParentId,
      location: ap.CityName_Vi,
    }));

  try {
    const tokenObj = getAccessToken();
    const headers = {
      Authorization: `Bearer ${tokenObj.access_token}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    };
    const fareConfig = await queryFareConfig();
    const fromQuery = `${process.env.VROUTE_BASE_URL}/v1/goyolo/area/${from}`;
    const toQuery = `${process.env.VROUTE_BASE_URL}/v1/goyolo/area/${to}`;
    const [fromApi, toApi] = await Promise.all([
      fetch(fromQuery, { headers }),
      fetch(toQuery, { headers }),
    ]);
    const fromData = fromApi.status === 200 ? await fromApi.json() : null;
    const toData = toApi.status === 200 ? await toApi.json() : null;

    const mapStartPoint = fromData
      ? transformAreaData([fromData?.data] || [])
      : fromAirports;

    const mapToPoint = toData
      ? transformAreaData([toData?.data] || [])
      : toAirports;

    return {
      props: {
        isServer: !!context.req,
        startPoint: mapStartPoint[0] || null,
        toPoint: mapToPoint[0] || null,
        passenger,
        fareConfig,
      },
    };
  } catch (error) {
    return {
      props: {
        isServer: !!context.req,
        startPoint: fromAirports[0] || null,
        toPoint: toAirports[0] || null,
        passenger: null,
        fareConfig: [],
      },
    };
  }
}

export default TripDetail;
